module.exports = __webpack_public_path__ + "static/media/contactlenses2.719e68bc.jpg";